import { render, staticRenderFns } from "./ReturnTop.vue?vue&type=template&id=04525ee5&scoped=true&"
import script from "./ReturnTop.vue?vue&type=script&lang=ts&"
export * from "./ReturnTop.vue?vue&type=script&lang=ts&"
import style0 from "./ReturnTop.vue?vue&type=style&index=0&id=04525ee5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04525ee5",
  null
  
)

export default component.exports